

export enum PaymentMethodCategoryEnum  {
    Card = "Card",
    CustomerWallet = "Wallet",
    AlternativePaymentMethod = "APM",
    NoPSP = "NOPSP"
}